module.exports = __webpack_public_path__ + "img/preview-2.6b2192af.png";